module.exports = __webpack_public_path__ + "static/media/north-melbourne-logo.5f7acdab.svg";